import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import TableManager from '../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import { blockedNumber, deleteNumber } from './actions';
import { filterInitialValues } from './constants';
import { dateFormat } from '../../utils';

const table = createTable();

const BlockList = () => {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'delete-number',
    deleteNumber,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('blockedNumber');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );


  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this Number ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            id: val?.id,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };


  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      cell: (props) => dateFormat(props.getValue()),
      isSortable: true,
      textAlign: 'left',

    }),
    table.createDataColumn('number', {
      id: 'number',
      header: 'Number',
      textAlign: 'left',
    }),
    table.createDataColumn('destination', {
      id: 'destination',
      header: 'Destination',
      textAlign: 'left',
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
      textAlign: 'right',
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="blockedNumber"
        fetcherFn={blockedNumber}
        title="Blocked Number"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={filterInitialValues}
        setFilters={setFilters}
        filters={filters}
      />
    </>
  );
};

export default BlockList;
